"use client";
import LocalStorage from "@workspace/casino_pages/legacyLayer/client/utils/storage/LocalStorage";
import SessionStorage from "@workspace/casino_pages/legacyLayer/client/utils/storage/SessionStorage";
import { setCookie } from "@workspace/cookies/browser";

const closeNotification = (notification: WorkerNotification) => {
  const { id } = notification.data;
  if (!id) {
    return;
  }
  const { dismissStrategy = { storage: "session" } } = notification;
  switch (dismissStrategy.storage) {
    case "cookie": {
      const { ttl = 0 } = dismissStrategy;
      const expires = new Date(Date.now() + ttl);
      setCookie(id, "true", { expires });
      break;
    }
    case "session":
      SessionStorage.setItem(id, "true");
      break;
    case "local":
      LocalStorage.setItem(id, "true");
      break;
    default:
      break;
  }
};

export default closeNotification;
